(() => {
  const STORE_TZ = "Europe/Warsaw";

  // FOMO windows
  const STEP_MIN = 30;
  const DAY_START_HOUR = 6;        // 06:00
  const NIGHT_DEADLINE_HOUR = 10;  // ФІКС: 10:00 для нічних замовлень
  const NIGHT_DEADLINE_MIN = 0;

  // Delivery promise: +3 business days from "today" (Warsaw date)
  const DELIVERY_BD = 3;

  // Актуальні польські свята 2026
  const HOLIDAYS = new Set([
    "2026-01-01", "2026-01-06", "2026-04-05", "2026-04-06", 
    "2026-05-01", "2026-05-03", "2026-05-14", "2026-05-24", 
    "2026-06-04", "2026-08-15", "2026-11-01", "2026-11-11", 
    "2026-12-25", "2026-12-26"
  ]);

  const root = () => document.getElementById("cart-fomo-delivery");

  function cartHasItems() {
    return document.querySelectorAll(".cart-item, .cart__item, .cart-drawer__item").length > 0;
  }

  function getZonedNowParts(timeZone) {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).formatToParts(new Date());

    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second)
    };
  }

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function makeUTCNoonDate(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
  }

  function ymdKeyFromUTCDate(dUtc) {
    const y = dUtc.getUTCFullYear();
    const m = pad2(dUtc.getUTCMonth() + 1);
    const d = pad2(dUtc.getUTCDate());
    return `${y}-${m}-${d}`;
  }

  function isBusinessDayUTC(dUtc) {
    const dow = dUtc.getUTCDay(); // 0 Sun ... 6 Sat
    if (dow === 0 || dow === 6) return false;
    if (HOLIDAYS.has(ymdKeyFromUTCDate(dUtc))) return false;
    return true;
  }

  function addBusinessDaysUTC(dUtc, bd) {
    let d = new Date(dUtc.getTime());
    let remaining = bd;
    while (remaining > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isBusinessDayUTC(d)) remaining--;
    }
    return d;
  }

  function formatPlFullDate(dUtc) {
    return new Intl.DateTimeFormat("pl-PL", {
      weekday: "long",
      day: "numeric",
      month: "long",
      timeZone: "UTC"
    }).format(dUtc);
  }

  function computeDeadline(now) {
    // Night mode: 00:00–05:59 -> 10:00 (dziś)
    if (now.hour < DAY_START_HOUR) {
      return { hour: NIGHT_DEADLINE_HOUR, minute: NIGHT_DEADLINE_MIN, label: "dziś" };
    }

    const nowTotal = now.hour * 60 + now.minute + now.second / 60;
    const nextTotal = Math.ceil(nowTotal / STEP_MIN) * STEP_MIN;

    let h = Math.floor(nextTotal / 60);
    let m = nextTotal % 60;

    // If rolls past 24:00 -> show 10:00 (jutro)
    if (h >= 24) return { hour: NIGHT_DEADLINE_HOUR, minute: NIGHT_DEADLINE_MIN, label: "jutro" };

    return { hour: h, minute: m, label: "dziś" };
  }

  function minutesUntilDeadline(now, deadline) {
    if (deadline.label !== "dziś") return null;

    const nowTotal = now.hour * 60 + now.minute + now.second / 60;
    const dlTotal = deadline.hour * 60 + deadline.minute;
    return Math.max(0, Math.floor(dlTotal - nowTotal));
  }

  function render() {
    const el = root();
    if (!el) return;

    if (!cartHasItems()) {
      el.innerHTML = "";
      el.style.display = "none";
      return;
    }

    el.style.display = "";

    const now = getZonedNowParts(STORE_TZ);

    const todayUTC = makeUTCNoonDate(now.year, now.month, now.day);
    const deliveryUTC = addBusinessDaysUTC(todayUTC, DELIVERY_BD);
    const deliveryStr = formatPlFullDate(deliveryUTC);

    const dl = computeDeadline(now);
    const deadlineStr = `${pad2(dl.hour)}:${pad2(dl.minute)}`;
    const minutesLeft = minutesUntilDeadline(now, dl);

    const countdownHtml = "";

    el.innerHTML = `
      <div class="cart-fomo-line2">
        Przewidywana dostawa:
        <span class="cart-fomo-date">${deliveryStr}</span>
      </div>

      <div class="cart-fomo-line1">
        Złóż zamówienie do <strong>${deadlineStr}</strong>${dl.label ? ` (${dl.label})` : ``}
      </div>

      ${countdownHtml}
    `;
  }

  function debounce(fn, wait = 120) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function observeCartUpdates() {
    const target =
      document.getElementById("main-cart-items") ||
      document.querySelector("cart-items") ||
      document.querySelector("#MainContent");

    if (!target) return;

    const rerender = debounce(render, 120);
    const obs = new MutationObserver(rerender);

    obs.observe(target, { childList: true, subtree: true });

    document.addEventListener("click", (e) => {
      const hit = e.target.closest("cart-remove-button, .quantity__button, a[href*='/cart/change']");
      if (!hit) return;
      setTimeout(render, 200);
      setTimeout(render, 700);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    render();
    observeCartUpdates();
    setInterval(render, 15 * 1000); // Оновлення кожні 15 сек
  });
})();